import { useSiteBranding } from "../../../hooks/useSiteBranding";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { Link } from "react-router-dom";
import styles from "../terms/terms.module.css";

const PrivacyPolicy = () => {

    useSiteBranding("Privacy Policy", null);

    return (<>
        <Header />

        <div>
            <div className={`${styles.BannerSec}`}>
                <img src="/images/contact-us-banner1.jpg" alt="" />
                <div className={`${styles.BannerTitleCU}`}>
                    <div className={`${styles.Container}`}>
                        <h1 className={`${styles.Heading}`}>Privacy Policy</h1>
                        <p className={`${styles.BannerSubtitle}`}>How we collect, use, and protect your data</p>
                    </div>
                </div>
            </div>

            <div className={`${styles.legalContent}`}>
                <div className={`${styles.Container}`}>

                    <div className={`${styles.updatedRow}`}>
                        <p className={`${styles.effectiveDate}`}>Effective Date: 1 May 2025</p>
                        <Link to="/terms" className={`${styles.crossLink}`}>Read our Terms & Conditions →</Link>
                    </div>

                    <p className={`${styles.intro}`}>
                        At Ezy Freight Logistics ("EFL", "we", "us", "our"), we are committed to protecting your
                        personal data and respecting your privacy. This Privacy Policy explains what information we
                        collect, how we use it, and the choices and rights you have. It forms part of, and should be
                        read alongside, our <Link to="/terms">Terms &amp; Conditions</Link>.
                    </p>

                    <nav className={`${styles.toc}`} aria-label="Table of contents">
                        <h2>On this page</h2>
                        <ul className={`${styles.tocGrid}`}>
                            <li><a href="#information-we-collect">1. Information We Collect</a></li>
                            <li><a href="#how-we-use">2. How We Use Your Information</a></li>
                            <li><a href="#sharing">3. Sharing Your Information</a></li>
                            <li><a href="#security">4. Data Security</a></li>
                            <li><a href="#your-rights">5. Your Rights</a></li>
                            <li><a href="#cookies">6. Cookies</a></li>
                            <li><a href="#retention">7. Retention</a></li>
                            <li><a href="#international-transfers">8. International Data Transfers</a></li>
                            <li><a href="#policy-changes">9. Changes to This Policy</a></li>
                            <li><a href="#contact">10. Contact Us</a></li>
                        </ul>
                    </nav>

                    <section id="information-we-collect" className={`${styles.legalSection}`}>
                        <h3 className={`${styles.sectionTitle}`}><span className={`${styles.sectionNumber}`}>1.</span> Information We Collect</h3>
                        <ul className={`${styles.plainList}`}>
                            <li><strong>Account Information</strong> — when you register, we collect your name, company details, email address, and contact information.</li>
                            <li><strong>Usage Data</strong> — we collect information on how you use our Services to improve the user experience.</li>
                            <li><strong>Payment Information</strong> — we use secure third-party processors to handle payment details; we do not store full card details ourselves.</li>
                        </ul>
                    </section>

                    <section id="how-we-use" className={`${styles.legalSection}`}>
                        <h3 className={`${styles.sectionTitle}`}><span className={`${styles.sectionNumber}`}>2.</span> How We Use Your Information</h3>
                        <ul className={`${styles.plainList}`}>
                            <li>To provide, operate, and maintain our Services.</li>
                            <li>To communicate with you regarding updates, support, and promotional offers.</li>
                            <li>To comply with our legal obligations.</li>
                        </ul>
                    </section>

                    <section id="sharing" className={`${styles.legalSection}`}>
                        <h3 className={`${styles.sectionTitle}`}><span className={`${styles.sectionNumber}`}>3.</span> Sharing Your Information</h3>
                        <ul className={`${styles.plainList}`}>
                            <li>We do not sell your personal data.</li>
                            <li>We may share your data with trusted third-party service providers necessary to deliver our Services.</li>
                            <li>We may disclose your information if required to do so by law.</li>
                        </ul>
                    </section>

                    <section id="security" className={`${styles.legalSection}`}>
                        <h3 className={`${styles.sectionTitle}`}><span className={`${styles.sectionNumber}`}>4.</span> Data Security</h3>
                        <p style={{ fontSize: "15.5px", lineHeight: "27px", color: "#444" }}>
                            We implement appropriate technical and organisational measures designed to protect your
                            personal data against unauthorised access, loss, or misuse.
                        </p>
                    </section>

                    <section id="your-rights" className={`${styles.legalSection}`}>
                        <h3 className={`${styles.sectionTitle}`}><span className={`${styles.sectionNumber}`}>5.</span> Your Rights</h3>
                        <ul className={`${styles.plainList}`}>
                            <li>You have the right to access, rectify, or erase your personal data.</li>
                            <li>You may object to processing or request data portability.</li>
                            <li>You can exercise these rights at any time by contacting us using the details below.</li>
                        </ul>
                    </section>

                    <section id="cookies" className={`${styles.legalSection}`}>
                        <h3 className={`${styles.sectionTitle}`}><span className={`${styles.sectionNumber}`}>6.</span> Cookies</h3>
                        <p style={{ fontSize: "15.5px", lineHeight: "27px", color: "#444" }}>
                            We use cookies to enhance your browsing experience. You can manage your cookie preferences
                            at any time through your browser settings.
                        </p>
                    </section>

                    <section id="retention" className={`${styles.legalSection}`}>
                        <h3 className={`${styles.sectionTitle}`}><span className={`${styles.sectionNumber}`}>7.</span> Retention</h3>
                        <p style={{ fontSize: "15.5px", lineHeight: "27px", color: "#444" }}>
                            We retain personal data only for as long as necessary to fulfil the purposes for which it
                            was collected, including for the purposes of satisfying any legal, accounting, or reporting
                            requirements.
                        </p>
                    </section>

                    <section id="international-transfers" className={`${styles.legalSection}`}>
                        <h3 className={`${styles.sectionTitle}`}><span className={`${styles.sectionNumber}`}>8.</span> International Data Transfers</h3>
                        <p style={{ fontSize: "15.5px", lineHeight: "27px", color: "#444" }}>
                            If we transfer your data outside the country where it was collected, we ensure appropriate safeguards are in place to
                            protect it in accordance with applicable data protection law.
                        </p>
                    </section>

                    <section id="policy-changes" className={`${styles.legalSection}`}>
                        <h3 className={`${styles.sectionTitle}`}><span className={`${styles.sectionNumber}`}>9.</span> Changes to This Policy</h3>
                        <p style={{ fontSize: "15.5px", lineHeight: "27px", color: "#444" }}>
                            We may update this Privacy Policy from time to time. We encourage you to review it
                            periodically. Material changes will be reflected in the Effective Date above.
                        </p>
                    </section>

                    <section id="contact" className={`${styles.legalSection}`}>
                        <h3 className={`${styles.sectionTitle}`}><span className={`${styles.sectionNumber}`}>10.</span> Contact Us</h3>
                        <p style={{ fontSize: "15.5px", lineHeight: "27px", color: "#444", marginBottom: "14px" }}>
                            If you have any questions about this Privacy Policy, please get in touch:
                        </p>
                        <div className={`${styles.contactCard}`}>
                            <p>Ezy Freight Logistics</p>
                            <p>Email: <a href="mailto:admin@eflogistics.io">admin@eflogistics.io</a></p>
                            <p>Registered Address: Unit 2&3 Bay Close, Progress Way, Luton, Beds, England, LU4 9UP</p>
                        </div>
                    </section>

                </div>
            </div>
        </div>

        <Footer />

    </>);
};

export default PrivacyPolicy;